import i18n from 'i18n'

export const MIN_REWARDS_COUNT = 1
export const MAX_REWARDS_COUNT = 1000
export const MIN_REWARD_QUANTITY = 1

export const WEIGHT = {
    NORMAL: 'NORMAL',
    VERY_HIGH: 'VERY_HIGH',
    HIGH: 'HIGH',
    LOW: 'LOW',
    VERY_LOW: 'VERY_LOW',
}

export const WEIGHT_FACTOR = {
    [WEIGHT.NORMAL]: 1,
    [WEIGHT.VERY_HIGH]: 3,
    [WEIGHT.HIGH]: 1.5,
    [WEIGHT.LOW]: 0.5,
    [WEIGHT.VERY_LOW]: 0.1,
}

export const REWARD_DATA = {
    [WEIGHT.NORMAL]: {
        value: WEIGHT.NORMAL,
        getLabel: percentage => `${i18n.t('Normal')}${percentage ? ` (${percentage}%)` : ''} `,
        factor: WEIGHT_FACTOR[WEIGHT.NORMAL],
    },
    [WEIGHT.VERY_HIGH]: {
        value: WEIGHT.VERY_HIGH,
        getLabel: percentage => `${i18n.t('Very High')}${percentage ? ` (${percentage}%)` : ''} `,
        factor: WEIGHT_FACTOR[WEIGHT.VERY_HIGH],
    },
    [WEIGHT.HIGH]: {
        value: WEIGHT.HIGH,
        getLabel: percentage => `${i18n.t('High')}${percentage ? ` (${percentage}%)` : ''} `,
        factor: WEIGHT_FACTOR[WEIGHT.HIGH],
    },
    [WEIGHT.LOW]: {
        value: WEIGHT.LOW,
        getLabel: percentage => `${i18n.t('Low')}${percentage ? ` (${percentage}%)` : ''} `,
        factor: WEIGHT_FACTOR[WEIGHT.LOW],
    },
    [WEIGHT.VERY_LOW]: {
        value: WEIGHT.VERY_LOW,
        getLabel: percentage => `${i18n.t('Very Low')} (${percentage}%)`,
        factor: WEIGHT_FACTOR[WEIGHT.VERY_LOW],
    },
}

export const REWARD_AVAILABILITY = {
    LIMITED: 'LIMITED',
    UNLIMITED: 'UNLIMITED',
}
export const REWARD_AVAILABILITY_OPTIONS = [
    {
        value: REWARD_AVAILABILITY.UNLIMITED,
        label: i18n.t('Unlimited '),
    },
    {
        value: REWARD_AVAILABILITY.LIMITED,
        label: i18n.t('Limited'),
    },
]
